// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "" + {"16":"33fb3450aeefd3c55d5a","945":"0bb7e221e3d0b5b004b4"}[chunkId] + ".js";
};